import { AuthError, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { handleSessionExpired } from "./helper/authSession";

// 網路類錯誤不視為登入失效
const NETWORK_ERROR_CODES = ["no_network_connectivity", "endpoints_resolution_error", "post_request_failed", "get_request_failed"];

export const msalInstance = new PublicClientApplication(msalConfig);


export const acquireAccessToken = async () => {
  const activeAccount = msalInstance.getActiveAccount(); // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const accounts = msalInstance.getAllAccounts();
  if (!activeAccount && accounts.length === 0) {
      /*
      * User is not signed in. Throw error or wait for user to login.
      * Do not attempt to log a user in outside of the context of MsalProvider
      */   
  }
  const request = {
      scopes: ["User.Read"],
      account: activeAccount || accounts[0]
  };

  try {
    const authResult = await msalInstance.acquireTokenSilent(request);
    return authResult.accessToken
  } catch (error) {
    // 微軟登入已失效(refresh token 過期、帳號不在快取等)：靜默導回登入頁，並標記讓呼叫端不跳錯誤
    if (error instanceof AuthError && !NETWORK_ERROR_CODES.includes(error.errorCode)) {
      error.isSessionExpired = true
      handleSessionExpired()
    }
    throw error
  }
};

